import { Component, OnInit } from "@angular/core";
import { UsersService } from "../services/users/users.service";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-my-results",
    templateUrl: "./my-results.component.html",
    styleUrls: ["./my-results.component.scss"],
})
export class MyResultsComponent implements OnInit {
    results: any[] = [];
    selectedResult: any = null;
    showHistory = true;
    loading = false;
    message: string | null = null;

    showingShareModal = false;
    currentShareUrl = "";
    shareExpiresAt: string | null = null;
    user: any = null;

    constructor(
        private usersService: UsersService,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        this.loadItems();
        this.loadUser();
    }
    loadUser(): void {
        this.usersService.getPatient().subscribe({
            next: (data) => {
                this.user = data;
                console.log("✅ User:", data);
            },
            error: (err) => {
                console.warn("⚠️ User API error:", err);
              
                this.user = null;
            },
        });
    }
    loadItems(): void {
        this.loading = true;
        this.message = "Se încarcă rezultatele...";

        this.usersService.getMyResults().subscribe({
            next: (data: any[]) => {
                this.results = (data || []).sort(
                    (a, b) =>
                        new Date(b.date).getTime() - new Date(a.date).getTime(),
                );
                this.loading = false;
                this.message = this.results.length
                    ? null
                    : "Nu ai rezultate medicale înregistrate.";
            },
            error: () => {
                this.loading = false;
                this.results = [];
                this.message = "A apărut o eroare la încărcarea rezultatelor.";
                this.toastr.error(this.message, "Rezultate");
            },
        });
    }

   loadDetails(result: any): void {
  // Call read API
  this.usersService.readResult(result.uuid).subscribe({
    next: () => {
      // Marchează local ca citit
      result.isRead = true;
      
      // Setează selectedResult și schimbă tab
      this.selectedResult = result;
      this.showHistory = false;
    },
    error: (err) => {
      console.error('Read error:', err);
      // Dacă API fail, tot arată detaliile
      this.selectedResult = result;
      this.showHistory = false;
    }
  });
}

    backToHistory(): void {
        this.showHistory = true;
        this.selectedResult = null;
    }

    download(result: any): void {
        if (!result?.downloadReference) {
            this.toastr.warning(
                "Nu există fișier de descărcat pentru acest rezultat.",
                "Descărcare",
            );
            return;
        }

        this.usersService.downloadResult(result.downloadReference).subscribe({
            next: (blob: Blob) => {
                // încerci să deduci extensia, dacă ai content-type din backend, poți îmbunătăți
                const fileName = `rezultat-${result.uuid || "medical"}.pdf`;

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            error: (err) => {
                console.error("Download error:", err);
                this.toastr.error(
                    "A apărut o eroare la descărcarea fișierului.",
                    "Descărcare",
                );
            },
        });
    }

    share(result: any): void {
        if (!result?.uuid) {
            this.toastr.warning(
                "Nu există UUID pentru acest rezultat",
                "Eroare",
            );
            return;
        }

        this.toastr.info("Se generează link de partajare...", "Trimite");

        this.usersService.shareResult(result.uuid).subscribe({
            next: (response: { shareUrl: string; expiresAt: string }) => {
                // ✅ Modal frumos cu link-ul
                this.showShareModal(response.shareUrl, response.expiresAt);
            },
            error: (err: any) => {
                console.error("Share error:", err);
                this.toastr.error("Eroare la generarea link-ului", "Trimite");
            },
        });
    }

    showShareModal(shareUrl: string, expiresAt: string): void {
        this.currentShareUrl = shareUrl;
        this.shareExpiresAt = new Date(expiresAt).toLocaleDateString("ro-RO");
        this.showingShareModal = true;
    }

    closeShareModal(): void {
        this.showingShareModal = false;
        this.currentShareUrl = "";
        this.shareExpiresAt = "";
    }

    copyShareLink(): void {
        navigator.clipboard.writeText(this.currentShareUrl).then(() => {
            this.toastr.success("Link copiat în clipboard!", "Copiat");
        });
    }

   openShareLink(): void {
    const url = `/result?token=${encodeURIComponent(this.currentShareUrl)}`;
    window.open(url, '_blank');
    this.closeShareModal();
}
getElement(result: any, code: string): any {
  return result?.elements?.find((el: any) => el?.elementType?.code === code) || null;
}

getChildElement(element: any, code: string): any {
  return element?.elements?.find((el: any) => el?.elementType?.code === code) || null;
}

getValue(item: any): string {
  return item?.values?.[0]?.valueAsString || "";
}
}
